<template>
    <div class="z-dealing-task">
        <div class="header">
            <span class="tip">任务来源:</span>
            <span class="select-box" @click="choose(0)" :class="{active:activeIndex == 0}">执行任务</span>
            <span class="select-box" @click="choose(1)" :class="{active:activeIndex == 1}">派发任务</span>
        </div>
    
        <listWrap @refresh="refresh" :data="data" :config="config" :keyStatus="key_status"></listWrap>
        <z-pagination @getPage="refresh" :data='data'></z-pagination>
    
    </div>
</template>

<script type="text/ecmascript-6">
    import listWrap from "src/components/tasklistTpl.vue"
    import { mapState } from "vuex";

    export default {
        components: {
            listWrap,
        },
        data() {
            return {
                data: {},  //放页面数据的
                key_status: 20,  //关键状态码
                config: {
                    source_type: 0,
                    template_id: 0,
                    process_status: 0
                }

            }
        },
        computed: {
            ...mapState({
                seachKeyWord: state => state.search.keyword,
            }),
            activeIndex(){
                return this.$route.query.tab || 0;
            },
        },

        created() {
            this.choose();
        },
        // mounted() {
        //     this.$store.dispatch('getSearchTip', "搜索任务名称/编号...");
        // },
        destroyed(){
            this.$store.dispatch('setId', "");
        },

        methods: {
            choose(id = this.activeIndex){
                this.$router.replace({
                    name:"dealing-task",
                    query:{
                        tab:id,
                    }
                });
                
                let obj = this.config;

                if (id == 0) {
                    obj.source_type = 2;  //自己是接收方
                } else if (id == 1) {
                    obj.source_type = 1;  //自己是发布方
                } else {
                    obj.source_type = 0;
                }

                this.refresh();

            },

            refresh(page) {   //获取列表
                let obj = {
                    ...this.config,
                    page:page,
                    keyword: this.seachKeyWord,
                };
                this.getData(obj);   
            },
            getData(obj){  //拉取数据
                let url = `api/clerk/task/dealing_list_page`;
                this.$http.get(url, {params:obj}).then(res => {
                    console.log("处理任务列表");
                    if(res.status == 200){
                        this.data = res.res_data;
                    }
                });
            },
        },

    };
</script>

<style lang="less">
@import "~src/assets/less/task.less";
</style>



// WEBPACK FOOTER //
// page-dealing.vue?63ae27f1